/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Tue Nov 08 2022
*  File : UserActionTypes.ts
*******************************************/

import { NotificationDeviceType } from "../api/types/SubscriptionTypes.js";

export enum TopicAction {
    FOLLOW = "FOLLOW",
    UNFOLLOW = "UNFOLLOW"
}

export enum BookmarkAction {
    BOOKMARK = "BOOKMARK",
    UNBOOKMARK = "UNBOOKMARK"
}

export enum NewlsetterAction {
    SUBSCRIBE = "NL_SUBSCRIBE",
    UNSUBSCRIBE = "NL_UNSUBSCRIBE"
}

export enum DeviceAction {
    SUBSCRIBE = "SUBSCRIBE",
    UNSUBSCRIBE = "UNSUBSCRIBE",
    ENABLE = "ENABLE",
    DISABLE = "DISABLE"
}


export interface DeviceSubscriptionDetails {
    action: DeviceAction,
    device: NotificationDeviceType,
}

export type StatDeviceType = keyof typeof NotificationDeviceType;

export function getStatDeviceTypeFromNotificationDeviceType(type: NotificationDeviceType): StatDeviceType {
    
    const found = (Object.keys(NotificationDeviceType) as StatDeviceType[]).filter(x => NotificationDeviceType[x] == type);
    if (found.length > 0) {
        return found[0];
    }
    else {
        return 'UNSPECIFIED';
    }
}